/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class VatField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>VAT</label>
        <Input
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          min="0"
          required
          onChange={e => onChange('vat', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/vatField.js